export default __webpack_public_path__ + "f06d28da9e0a4e89c4d395dbd8671884.wav";